// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3-TDz","image":"Header_image__102Ea","name":"Header_name__3vbOc","info":"Header_info__3Uaw5","infoRow":"Header_infoRow__11XAG"};